module.exports = __webpack_public_path__ + "img/583648001.daec3982.jpg";